export const Delivery = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <g mask='url(#mask0_7401_21683)'>
        <path
          d='M18.7499 7.49979H16.495L15.3277 4.44285C15.0263 3.65465 14.2575 3.12549 13.4138 3.12549H6.58669C5.74294 3.12549 4.97419 3.65465 4.6728 4.44285L3.50475 7.49979H1.8728L1.2478 9.37479H2.49989V12.3262C2.49989 12.9033 2.74016 13.4248 3.12489 13.797V16.2498H4.99989V14.3748H14.9999V16.2498H16.8749V13.797C17.2596 13.4241 17.4999 12.9026 17.4999 12.3262V9.37479H18.1249L18.7499 7.49979ZM4.37489 12.3262V9.37479H15.6249V12.3262C15.6249 12.422 15.5471 12.4998 15.4513 12.4998H4.5485C4.45266 12.4998 4.37489 12.422 4.37489 12.3262ZM6.58669 5.00049H13.4138C13.4853 5.00049 13.5506 5.04563 13.5763 5.11229L14.4881 7.49979H5.51239L6.42419 5.11229C6.44989 5.04424 6.51377 5.00049 6.58669 5.00049Z'
          fill='var(--colorIconPrimary)'
        />
        <path
          d='M11.875 11.875H14.375L15 10H12.5L11.875 11.875Z'
          fill='var(--colorIconPrimary)'
        />
        <path
          d='M5 10L5.625 11.875H8.125L7.5 10H5Z'
          fill='var(--colorIconPrimary)'
        />
      </g>
    </svg>
  );
};
